export default function setCountryErrAction(countryError) {
    return {
        type: 'SET_COUNTRY_ERR',
        payload: countryError
    }
}